<div class="row" >
  <div class="w-100 p-2">
    <div class="card rapporti-card p-0" style="min-height: 570px;">
      <div class="header-zona h-25">
        <span class="titolo-card-doc">Annali ex SIMN</span>
      </div>
      <div class="card-body rapporti-doc h-75" style="min-height: 50px;">
        <div class="navigation-wrapper">
          <div class="titolo-nav d-flex flex-column align-content-center">
            <h4 style="text-align: center;">ANNALI IDROLOGICI E ALTRE PUBBLICAZIONI</h4>
            <h5 style="text-align: center;"><em>del compartimento di Napoli del S.I.M.N.</em></h5>
          </div>
          <div class="body-nav py-4 d-flex flex-column justify-content-center">
            <div class="w-100 d-flex justify-content-center mb-2">
              <h4 style="text-align: center;">{{titoloSezione(navigazioneAnnali)}}</h4>
            </div>
            <div *ngIf="navigazioneAnnali != 0" class="body-footer w-100 pb-4 d-flex justify-content-center">
              <button class="btn btn-primary col-md-2 col-sm-12 bottone-annali" (click)="updateNavigation(0)">
                <span class="h5">Indietro</span>
              </button>
            </div>
            <div *ngIf="navigazioneAnnali == 0" class="annali-home row w-100 justify-content-center">
              <button class="btn btn-primary col-md-5 col-sm-12 bottone-annali m-1">
                <a style="
    text-decoration: none;" (click)="openPdfDocument(websiteUrl + 'Storia/Storia/presentazione-annali-idrologici.pdf')" href="javascript:void(0)"><span class="h5">Presentazione annali idrologici</span></a>
              </button>
              <button class="btn btn-primary col-md-5 col-sm-12 bottone-annali m-1" (click)="updateNavigation(2)">
                <span class="h5">Gli annali</span>
              </button>
              <button class="btn btn-primary col-md-5 col-sm-12 bottone-annali m-1" (click)="updateNavigation(3)">
                <span class="h5">Le pubblicazioni</span>
              </button>
              <button class="btn btn-primary col-md-5 col-sm-12 bottone-annali m-1" (click)="updateNavigation(4)">
                <span class="h5">La carta delle stazioni</span>
              </button>
            </div>
            <div *ngIf="navigazioneAnnali == 2" class="annali-annali w-100 justify-content-center">
              <ng-container *ngTemplateOutlet="annali"></ng-container>
            </div>
            <div *ngIf="navigazioneAnnali == 3" class="annali-pubblicazioni w-100 justify-content-center">
              <ng-container *ngTemplateOutlet="pubblicazioni"></ng-container>
            </div>
            <div *ngIf="navigazioneAnnali == 4" class="annali-stazioni row w-100 justify-content-center">
              <button class="btn btn-primary btn-large col-md-5 col-sm-12 bottone-annali m-1">
                <span class="h5"><a style="color:#fff;
    text-decoration: none;" [href]="websiteUrl + 'Carta%20delle%20stazioni/Carta%20delle%20stazioni/pluviometri_annali.pdf'" target="_blank">Carta dei pluviometri</a></span>
              </button>
              <button class="btn btn-primary btn-large col-md-5 col-sm-12 bottone-annali m-1">
                <span class="h5">
                  <a style="color:#fff;
    text-decoration: none;" [href]="websiteUrl + 'Carta%20delle%20stazioni/Carta%20delle%20stazioni/CoordinateDVD.pdf'" target="_blank">
                    Coordinate delle stazioni</a>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noDocument>
  <div class="w-100">
    <div class="card p-0 mx-4" style="min-height: 550px;">
      <div class="card-body rapporti-doc d-flex justify-content-center" style="min-height: 50px;">
        <span class="h4">Non sono presenti documenti da visualizzare</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pubblicazioni>
  <div class="w-100">
    <table class="table-pubblicazioni table table-striped border">
      <thead>
        <tr>
          <th class="middle-text" scope="col">Pubblicazione</th>
          <th class="middle-text" scope="col">Titolo</th>
          <th class="middle-text" scope="col">Allegati</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>-</th>
          <td class="middle-text"><a (click)="openPdfDocument(websiteUrl + 'Pubblicazioni/Pubblicazioni/P00_Superficie%20dei%20bacini%20imbriferi%20.pdf')" href="javascript:void(0)">Superficie dei bacini imbriferi</a></td>
          <td>-</td>
        </tr>
        <tr>
          <th>P14 vol. VII</th>
          <td class="middle-text">Le sorgenti italiane</td>
          <td>
            <table class="table2 w-100 d-flex flex-column align-items-center">
                  <tr><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P14_Le_Sorgenti_Italiane_Carta_1.pdf '" target="_blank">Carta 1</a></tr>
                  <tr><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P14_Le_Sorgenti_Italiane_Carta_2.pdf'" target="_blank">Carta 2</a></tr>
                  <tr><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P14_Le_Sorgenti_Italiane_Carta_3.pdf'" target="_blank">Carta 3</a></tr>
                  <tr><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P14_Le_Sorgenti_Italiane_Carta_4.pdf'" target="_blank">Carta 4</a></tr>
                  <tr><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P14_Le_Sorgenti_Italiane_Carta_4.pdf'" target="_blank">Carta 5</a></tr>
                  <tr><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P14_Le_Sorgenti_Italiane_Carta_geologica_piogge.pdf'" target="_blank">Carta geologica e delle piogge</a></tr>
                </table>
          </td>
        </tr>
        <tr>
          <th>P17</th>
          <td>
            <div class="w-100 d-flex flex-column">
              <div class="border-bottom w-100 px-2 pb-2" style="text-align: center;">
                Dati caratteristici dei corsi d'acqua italiani (stralcio compartimento di Napoli)
              </div>
              <div class="w-100 d-flex justify-content-around px-2 pt-2">
                <span >1935</span>
                <span >1950</span>
                <span >1960</span>
                <span >1970</span>
                <span >1980</span>
              </div>
            </div>
          </td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">-</td>
        </tr>
        <tr>
          <th>P21 vol. IV</th>
          <td class="middle-text">La distribuzione della temperatura dell'aria in Italia nel trentennio 1926 - 1955</td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">-</td>
        </tr>
        <tr>
          <th>P24 vol. X</th>
          <td class="middle-text">
          <a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P24_10_Precipitazioni_Medie_Mensili_ed_Annue_1921-50.pdf'" target="_blank">
          Precipitazioni medie mensili ed annue 1921 - 1950</a></td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">
          <a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P24_13_La_Carta_della_Precipitazione_Media_Annua_in_Italia_1921-1950_Carta_Isoiete.pdf'" target="_blank">
          Carta isoiete</a></td>
        </tr>
        <tr>
          <th>P24 vol. XIII</th>
          <td class="middle-text">
            <a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P24_13_La_Carta_della_Precipitazione_Media_Annua_in_Italia_1921-1950.pdf'" target="_blank">
              La carta della precipitazione media annua in Italia 1921 - 1950</a></td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">
          <a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/P24_13_La_Carta_della_Precipitazione_Media_Annua_in_Italia_1921-1950_Carta_Isoiete.pdf'" target="_blank">Carta isoiete</a></td>
        </tr>
        <tr>
          <th>P25 vol. IX</th>
          <td class="middle-text"><a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/Pubblicazioni/P25_9_Precipitazioni_Massime_da_Uno_a_Cinque_Giorni_Consecutivi.pdf'" target="_blank">
          Precipitazioni massime da uno a cinque giorni consecutivi</a></td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">-</td>
        </tr>
        <tr>
          <th>P26</th>
          <td class="middle-text">La nevosità in Italia</td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">
          Carta nevosità</td>
        </tr>
        <tr>
          <th>P27</th>
          <td class="middle-text">
            <a [href]="websiteUrl + 'Pubblicazioni/Pubblicazioni/Pubblicazioni/P27_Elenco_delle_Stazioni_Termopluviometriche_Del_Servizio_Idrografico_Italiano_stralcio_NA.pdf'" target="_blank">
              Elenco delle stazioni termopluviometriche del Servizio Idrografico Italiano (stralcio compartimento di Napoli)</a></td>
          <td class="d-flex justify-content-center align-content-center w-100 h-100">-</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #annali>
  <div class="w-100">
    <table class="table-pubblicazioni table table-striped border">
      <tbody>
        <tr>
          <td >1916</td>
          <td rowspan="2" colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1916-1917_Osservazioni_Pluviometriche.pdf'" target="_blank">Osservazioni
            pluviometriche</a></td>
          <td rowspan="2">-</td>
        </tr>
        <tr>
          <td >1917</td>
        </tr>
        <tr>
          <td >1918</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1918_Bollettino_Mensile.pdf'" target="_blank">Bollettino mensile</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1918_Bollettino_Mensile_Appendice.pdf'" target="_blank">Appendice</a></td>
        </tr>
        <tr>
          <td rowspan="2">1919</td>
          <td colspan="4">Bollettino mensile</td>
          <td rowspan="2"><a [href]="websiteUrl + 'Annali/Annali/1919_Bollettino_Mensile_Appendice.pdf'" target="_blank">Appendice</a></td>
        </tr>
        <tr>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1919_Bollettino_Mensile_1_trimestre.pdf'" target="_blank">I trimestre</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1919_Bollettino_Mensile_2_trimestre.pdf'" target="_blank">II trimestre</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1919_Bollettino_Mensile_3_trimestre.pdf'" target="_blank">III trimestre</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1919_Bollettino_Mensile_4_trimestre.pdf'" target="_blank">IV trimestre</a></td>
        </tr>
        <tr>
          <td >1920</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1920_Bollettino_Mensile.pdf'" target="_blank">Bollettino mensile</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1921</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1921_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1921_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1922</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1922_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1922_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1923</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1923_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1923_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1924</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1924_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1924_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1925</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1925_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1925_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1926</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1926_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1926_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1927</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1927_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1927_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1928</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1928_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1928_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1929</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1929_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1929_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1930</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1930_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1930_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1931</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1931_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1931_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1932</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1932_Annale_Parte_01.pdf'" target="_blank">Annale parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1932_Annale_Parte_02.pdf'" target="_blank">Annale parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1933</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1933_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1933_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1934</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1934_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1934_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1935</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1935_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1935_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1936</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1936_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1936_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1937</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1937_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1937_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1938</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1938_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1938_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1939</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1939_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1939_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1940</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1940_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1940_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1941</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1941_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1941_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1942</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1942_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1942_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1943</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1943_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1944</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1944_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1945</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1945_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1946</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1946_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1947</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1947_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1948</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1948_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1949</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1949_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1950</td>
          <td colspan="4"><a [href]="websiteUrl + 'Annali/Annali/1950_Annale_Parte_01-02.pdf'" target="_blank">Annale
            parte 1-2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1951</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1951_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1951_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1951_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1952</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1952_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1952_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1952_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1953</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1953_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1953_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1953_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1954</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1954_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1954_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1954_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1955</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1955_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1955_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1955_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1956</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1956_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1956_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1956_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1957</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1957_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1957_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1957_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1958</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1958_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1958_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1958_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1959</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1959_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1959_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1959_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1960</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1960_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1960_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1960_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1961</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1961_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1961_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1961_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1962</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1962_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1962_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1962_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1963</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1963_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1963_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1963_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1964</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1964_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1964_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1964_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1965</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1965_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1965_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1965_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1966</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1966_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1966_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1966_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1967</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1967_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1967_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1967_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1968</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1968_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1968_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1968_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1969</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1969_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1969_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td ><a [href]="websiteUrl + 'Annali/Annali/1969_Carta_Isoiete.pdf'" target="_blank">Carta
            isoiete</a></td>
        </tr>
        <tr>
          <td >1970</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1970_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1970_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1971</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1971_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1971_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1972</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1972_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1972_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1973</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1973_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1973_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1974</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1974_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1974_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1975</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1975_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1975_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1976</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1976_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1976_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1977</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1977_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1977_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1978</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1978_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1978_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1979</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1979_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1979_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1980</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1980_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1980_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1981</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1981_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1981_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1982</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1982_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1982_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1983</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1983_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1983_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1984</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1984_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1984_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1985</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1985_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1985_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1986</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1986_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1986_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1987</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1987_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1987_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1988</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1988_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1988_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1989</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1989_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1989_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1990</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1990_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1990_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1991</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1991_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1991_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1992</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1992_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1992_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1993</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1993_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1993_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1994</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1994_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1994_Annale_Parte_02.pdf'" target="_blank">Annale
            parte 2</a></td>
          <td >-</td>
        </tr>
        <tr>
          <td >1995</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1995_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2">-</td>
          <td >-</td>
        </tr>
        <tr>
          <td >1996</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1996_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2">-</td>
          <td >-</td>
        </tr>
        <tr>
          <td >1997</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1997_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2">-</td>
          <td >-</td>
        </tr>
        <tr>
          <td >1998</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1998_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2">-</td>
          <td >-</td>
        </tr>
        <tr>
          <td >1999</td>
          <td colspan="2"><a [href]="websiteUrl + 'Annali/Annali/1999_Annale_Parte_01.pdf'" target="_blank">Annale
            parte 1</a></td>
          <td colspan="2">-</td>
          <td >-</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>